module.exports = __webpack_public_path__ + "static/media/hot-dog-bike.b0e0e12f.svg";